import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { t } from "@auto/services";
import { VoterApplicationListFacetButton } from "@src/lists/VoterApplicationListFacets";
import styles from "@src/lists/VoterApplicationListFacets.module.styl";

const PENDING = "PENDING_REVIEW";
const STATUSES = [PENDING, "APPROVED", "REJECTED", ""];

export const normalizeAdjudicationListFilters = (value) => {
  const raw = value?.status;
  const status = raw === "" || STATUSES.includes(raw) ? raw : PENDING;
  return { status };
};

const StatusFilterDrawer = ({ controller }) => {
  const selected = normalizeAdjudicationListFilters(controller.value).status;
  return (
    <div className={styles.drawer}>
      <div className={styles.drawerHeader}>
        <div className={styles.drawerTitle}>{t("common.filters")}</div>
        <button type="button" className={styles.closeButton}
          onClick={controller.closeDrawer} aria-label={t("common.closeFilters")}>
          <CloseIcon fontSize="inherit" />
        </button>
      </div>
      <div className={styles.drawerBody}>
        <section className={styles.section}>
          <div className={styles.sectionTitle}>{t("common.status")}</div>
          <div className={styles.sectionBody}>
            {STATUSES.map((status) => (
              <button key={status || "all"} type="button" aria-pressed={selected === status}
                className={selected === status
                  ? `${styles.option} ${styles.optionSelected}` : styles.option}
                onClick={() => controller.setValue({ status })}>
                <span className={styles.radioDot} aria-hidden="true" />
                <span className={styles.optionLabel}>{status
                  ? t(`adjudication.status.${status}`) : t("adjudication.allStatuses")}</span>
              </button>
            ))}
          </div>
        </section>
      </div>
      <div className={styles.drawerFooter}>
        <button type="button" className={styles.secondaryAction}
          disabled={!controller.activeCount} onClick={controller.reset}>
          {t("common.resetFilters")}
        </button>
        <button type="button" className={styles.primaryAction} onClick={controller.closeDrawer}>
          {t("common.done")}
        </button>
      </div>
    </div>
  );
};

const StatusFilterChips = ({ controller }) => {
  const status = normalizeAdjudicationListFilters(controller.value).status;
  if (status === PENDING) return null;
  return <div className={styles.chipsBar}>
    <button type="button" className={styles.chip} onClick={controller.reset}>
      {t("common.status")}: {status
        ? t(`adjudication.status.${status}`) : t("adjudication.allStatuses")}
      <span className={styles.chipClose} aria-hidden="true">×</span>
    </button>
  </div>;
};

// Same facet controller/button/drawer styling used by the voter-application list.
// The two adjudication menus have separate persisted filter settings.
export const createAdjudicationListFacets = (kind) => ({
  storageKey: `adjudication.${kind}.facets`,
  overlayLabel: t("common.filters"),
  defaultValue: { status: PENDING },
  normalizeValue: normalizeAdjudicationListFilters,
  isDefaultValue: (value) => normalizeAdjudicationListFilters(value).status === PENDING,
  getActiveCount: (value) => normalizeAdjudicationListFilters(value).status === PENDING ? 0 : 1,
  renderButton: (controller) => <VoterApplicationListFacetButton controller={controller} />,
  renderDrawer: (controller) => <StatusFilterDrawer controller={controller} />,
  renderChips: (controller) => <StatusFilterChips controller={controller} />,
});
